<template>
    <div class="card-status" @mouseenter="hover = true" @mouseleave="hover = false" @click="ativaExibicaoStatus">
        <div class="card-content">
            <div style="color: var(--advice_friendly);font-size:1.1rem" class="mb-1">{{ processo }}:</div>
            <div class="status" :class="{ 'hovered': hover || processoAtualEstaAtivo }" :style="{ color: hover || processoAtualEstaAtivo ? '#333' : barColor }">
                <i v-if="iconClasses" :class="iconClasses" class="mr-2 icon" :style="{ color: hover || processoAtualEstaAtivo ? '#333' : barColor }"></i>{{ status === 'Finalizado' ? 'Finalizada' : status }}
            </div>
            <div v-if="updatedAt"
                 class="last-updated">
                {{ textoAtualizacao }}: {{ updatedAt | toDateBR }}
            </div>
        </div>
        <div class="progress-bar-static" :style="{ backgroundColor: barColor }"></div>
        <div class="progress-bar-dynamic" :style="{ width: progressBarWidth, backgroundColor: barColor }"></div>
    </div>
</template>

  <script>
  export default {
    name: 'CardStatus',
    props: {
      barColor: { type: String, default: 'gray' },
      processo: { type: String, default: 'Processo' },
      status: { type: String, default: 'Não Determinado' },
      iconClasses: { type: String, default: '' },
      processoAtivo: { type: String, default: '' },
      updatedAt: { type: String, default: '' },
      textoAtualizacao: { type: String, default: 'Atualizado' }
    },
    data: () => ({ hover: false }),
    computed: {
      progressBarWidth () { return this.hover || this.processoAtualEstaAtivo ? 'calc(100% - 10px)' : '0%' },
      processoAtualEstaAtivo () { return this.processoAtivo === this.processo }
    },
    methods: {
      ativaExibicaoStatus () {
        this.$emit('ativaExibicaoStatus', this.processo, this.status)
      }
    }
  }
  </script>
    <style scoped>
        .card-status {
        position: relative;
        overflow: hidden;
        height: 100%;
        cursor: pointer;
        }

        .card-content {
        position: relative;
        z-index: 1;
        padding: 16px;
        padding-bottom: 8px;
        margin-left: 5px;
        padding-top:10px
        }

        .progress-bar-static {
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 100%;
        opacity: 0.8;
        }

        .progress-bar-dynamic {
        position: absolute;
        top: 0;
        left: 10px;
        height: 100%;
        width: 0%;
        transition: width 0.3s ease;
        z-index: 0;
        opacity: 0.8;
        }

        .status {
        transition: font-weight 0.2s ease-out, color 0.2s ease-out; /* Transição para a cor */
        font-size: 1.3rem;
        font-weight: 700;
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        }

        .status.hovered {
        font-weight: bold;
        }
        .icon{
            font-size: 1.4rem;
        }
        .last-updated {
          font-size: 1.2rem;
          color: var(--advice_friendly)
        }
    </style>
